import '../color-swatch';
import '../tooltip';
import { getSwatchColorFg } from '../color-swatch/utils';
import { defineCustomElement, getAttribute, NectaryElement, updateAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0}#wrapper{width:44px;height:56px;padding:12px 6px;box-sizing:border-box}#swatch-wrapper{position:relative;cursor:pointer;width:32px;height:32px}#swatch-wrapper::after{content:"";position:absolute;width:34px;height:34px;inset:-3px;border:2px solid var(--sinch-comp-color-menu-option-color-default-border-initial);border-radius:50%;pointer-events:none}:host([data-checked]) #swatch-wrapper::after{border-color:var(--sinch-comp-color-menu-option-color-default-border-selected)}:host([data-selected]) #swatch-wrapper::after{border-color:var(--sinch-comp-color-menu-option-color-default-border-focus)}:host(:hover) #swatch-wrapper::after{border-color:var(--sinch-comp-color-menu-option-color-default-border-hover)}:host(:active) #swatch-wrapper::after{border-color:var(--sinch-comp-color-menu-option-color-default-border-active)}</style><div id="wrapper"><sinch-tooltip id="tooltip"><div id="swatch-wrapper"><sinch-color-swatch id="swatch"></sinch-color-swatch></div></sinch-tooltip></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-color-menu-option', class extends NectaryElement {
  #$wrapper;
  #$tooltip;
  #$swatch;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$wrapper = shadowRoot.querySelector('#wrapper');
    this.#$tooltip = shadowRoot.querySelector('#tooltip');
    this.#$swatch = shadowRoot.querySelector('#swatch');
  }
  connectedCallback() {
    this.role = 'option';
  }
  disconnectedCallback() {}
  static get observedAttributes() {
    return ['value'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'value':
        {
          updateAttribute(this.#$tooltip, 'text', newVal);
          updateAttribute(this.#$swatch, 'name', newVal);
          if (newVal !== null) {
            this.#$wrapper.style.setProperty('--sinch-global-color-icon', getSwatchColorFg(newVal));
          } else {
            this.#$wrapper.style.removeProperty('--sinch-global-color-icon');
          }
          break;
        }
    }
  }
  set value(value) {
    updateAttribute(this, 'value', value);
  }
  get value() {
    return getAttribute(this, 'value', '');
  }
});